import EditAddOnCategory from './EditAddOnCategory';

export default EditAddOnCategory;
